module.exports = __webpack_public_path__ + "static/media/recoverPasswordBg.650ff763.jpg";